/**
 * PayHOA legal and policy URLs on the marketing site.
 *
 * The marketing site is the single source of truth for these documents — SD-8985 removed the
 * copies that were embedded in Angular dialogs, which had drifted (the Terms sat 5 months behind
 * the published version, the Privacy Policy nearly 3 years). Everything in the app that shows a
 * user these documents links here.
 *
 * Both paths are permanent redirects (`/terms` → `/terms-conditions/`, `/privacy` →
 * `/privacy-policy/`). The short forms are kept because they are already what the app sends to
 * Stripe during Connect onboarding.
 */
export const PAYHOA_URLS = {
    /** PayHOA Terms of Service */
    TERMS_OF_SERVICE: 'https://www.payhoa.com/terms',

    /** PayHOA Privacy Policy */
    PRIVACY_POLICY: 'https://www.payhoa.com/privacy',
} as const;
